import { useState, useEffect, useCallback } from "react";
import api from "api";

export const useDashboardMetrics = (dateRange, { token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMetrics = useCallback(
    async (start, end) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get("/v2/stripe/dashboard-metrics", {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            start_date: start.toISOString().split("T")[0],
            end_date: end.toISOString().split("T")[0],
            subscribers_limit: 200,
            subscribers_offset: 0
          }
        });
        setData(response.data);
      } catch (err) {
        console.error("Erro ao buscar métricas do dashboard:", err);
        setError("Não foi possível carregar as métricas do servidor.");
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      fetchMetrics(dateRange.startDate, dateRange.endDate);
    }
  }, [dateRange, fetchMetrics]);

  return { data, loading, error };
};
